import React, { useRef, useCallback, useState, ChangeEvent, useEffect } from "react";
import { FormHandles } from "@unform/core";
import { Form } from "@unform/web";
import { Link } from "react-router-dom";
import * as Yup from "yup";
import { LoginFormContent } from "./styles";
import { Input, Button } from "../../../Components/Atoms";
import Tooltip from "../../../Components/Atoms/Tooltip";
import { handleTaxIDLoginInput } from "../../../Utils/masks";
import getValidationErrors from "../../../Utils/getValidationErrors";
import { useAuth } from "../../../Contexts/AuthContext";
import { FiUser, FiLock, FiUserPlus, FiKey, FiLogIn } from "react-icons/fi";
import ReCAPTCHA from "react-google-recaptcha";

interface ILoginFormData {
  password: string;
  username: string;
}

const authSchema = Yup.object().shape({
  username: Yup.string()
    .required("CPF/CNPJ obrigatório."),
  password: Yup.string().min(
    8,
    "Senha obrigatória, no mínimo 8 digitos."
  ),
});

const Login: React.FC = () => {
  //SET CAPTCHA FAZ A REQ DE LOGIN
  const formRef = useRef<FormHandles>(null);
  const [inputMask, setInputMask] = useState("");

  const { auth, isLoading } = useAuth();

  const [captcha, setCaptcha] = useState('');

  useEffect(() => {
    if (!window.grecaptcha || !window.grecaptcha.enterprise) return;

    window.grecaptcha.enterprise.ready(async () => {
      const captchaToken = await window.grecaptcha.enterprise.execute(
        process.env.REACT_APP_SITE_KEY,
        { action: "login" }
      );

      setCaptcha(captchaToken);
    });
  }, []);

  const handleSubmit = useCallback(
    async (data: ILoginFormData) => {
      try {
        await authSchema.validate(data, {
          abortEarly: false,
        });

        await auth({ 
          username: data.username,
          password: data.password,
          captcha
        })

      } catch (err) {
        if (err instanceof Yup.ValidationError) {
          const errors = getValidationErrors(err);
          formRef.current?.setErrors(errors);
          return;
        }
      }
    },
    [captcha]
  );

  return (
    <LoginFormContent>
      <h1>Bem vindo!</h1>
      <span> Para acessar, por favor faça o login.</span>
      <Form ref={formRef} onSubmit={handleSubmit}>
        <Input
          value={inputMask}
          type="text"
          name="username"
          placeholder="CPF ou CNPJ ou Email"
          leftIcon={<FiUser />}
          onChange={(e: ChangeEvent<HTMLInputElement>) => {
            setInputMask(handleTaxIDLoginInput(e.currentTarget.value));
          }}
        />
        <div style={{ display: 'flex', justifyContent: 'space-between' }}>
          <Tooltip title="Primeiro acesso: crie sua senha e ative seu usuário.">
            <Link to="/auth/my-first-access" tabIndex={-1}>
              <FiUserPlus /> Primeiro Acesso?
            </Link>
          </Tooltip>
          <Tooltip title="Recupere o acesso caso não lembre sua senha.">
            <Link to="/" tabIndex={-1}>
              <FiKey /> Esqueceu sua senha?
            </Link>
          </Tooltip>
        </div>
        <Input
          id="passwordInput"
          name="password"
          placeholder="Senha"
          type="password"
          leftIcon={<FiLock />}
        />

        <div style={{ display: 'flex', justifyContent: 'center', margin: '10px 0px' }}>
          <ReCAPTCHA sitekey='6LdkzpcsAAAAAPeSwFzUCX7m7z2NRkHJTiFNl8Xb' onChange={token => setCaptcha(token)} />
        </div>

        <Button
          type="submit"
          loading={isLoading}
          disabled={!captcha}
          height="calc(2.5rem + 2px)"
          fontSize="1.125rem"
          fontWeight="700"
        >
          <FiLogIn /> Entrar
        </Button>

        

      </Form>
    </LoginFormContent>
  )
};

export default Login;
